import React from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";


const LandingPage = () => {
  const navigate = useNavigate();

  const handleNavigateDashboard = () => navigate("/history");
  const handleNavigateRoleReview = () => navigate("/preview");

  return (
    <PageWrap>
      {/* Decorative background blobs */}
      <BlobTop />
      <BlobBottom />

      <ContentWrap>

        {/* Heading */}
        <WelcomeTitle variant="h1">Welcome to ActivateHR</WelcomeTitle>
        <WelcomeSubtitle variant="body1">
          Your complete HR management platform. Choose an option below to get started.
        </WelcomeSubtitle>

        {/* Button Cards */}
        <CardsRow>
          <ActionCard onClick={handleNavigateDashboard}>
            <CardIcon>📊</CardIcon>
            <CardTitle variant="h6">Dashboard</CardTitle>
            <CardDesc variant="body2">
              View and modify your existing role review summaries
            </CardDesc>
            <CardBtn variant="contained">Go to Dashboard</CardBtn>
          </ActionCard>

          <ActionCard onClick={handleNavigateRoleReview}>
            <CardIcon>📝</CardIcon>
            <CardTitle variant="h6">Role Review</CardTitle>
            <CardDesc variant="body2">
              Start a new role review process for your current role
            </CardDesc>
            <CardBtn variant="contained">Start a RoleReview</CardBtn>
          </ActionCard>
        </CardsRow>
      </ContentWrap>
    </PageWrap>
  );
};

export default LandingPage;

/* ── Styled Components ── */

const PageWrap = styled(Box)(() => ({
  minHeight: "100vh",
  background: "linear-gradient(145deg, #fff8f4 0%, #fff3ec 50%, #fde8d8 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "hidden",
  padding: "40px 16px",
}));

const BlobTop = styled(Box)(() => ({
  position: "absolute",
  top: "-120px",
  right: "-120px",
  width: "400px",
  height: "400px",
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(242,128,33,0.18) 0%, transparent 70%)",
  pointerEvents: "none",
}));

const BlobBottom = styled(Box)(() => ({
  position: "absolute",
  bottom: "-100px",
  left: "-100px",
  width: "350px",
  height: "350px",
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(16,133,171,0.12) 0%, transparent 70%)",
  pointerEvents: "none",
}));

const ContentWrap = styled(Box)(() => ({
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  maxWidth: "900px",
  width: "100%",
}));


const WelcomeTitle = styled(Typography)(() => ({
  fontSize: "36px",
  fontWeight: "700",
  color: "#1a1a2e",
  lineHeight: "1.2",
  marginBottom: "12px",
  "@media (max-width: 600px)": {
    fontSize: "26px",
  },
}));

const WelcomeSubtitle = styled(Typography)(() => ({
  fontSize: "17px",
  fontWeight: "400",
  color: "#6b7280",
  lineHeight: "1.6",
  marginBottom: "48px",
  maxWidth: "480px",
}));

const CardsRow = styled(Box)(() => ({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  width: "100%",
  "@media (max-width: 640px)": {
    flexDirection: "column",
    alignItems: "center",
  },
}));

const ActionCard = styled(Box)(() => ({
  background: "#ffffff",
  borderRadius: "20px",
  padding: "36px 28px",
  width: "100%",
  maxWidth: "340px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  boxShadow: "0 8px 32px rgba(242,128,33,0.10), 0 2px 8px rgba(0,0,0,0.06)",
  border: "1.5px solid rgba(242,128,33,0.12)",
  cursor: "pointer",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0 20px 48px rgba(242,128,33,0.18), 0 4px 16px rgba(0,0,0,0.08)",
  },
}));

const CardIcon = styled(Box)(() => ({
  fontSize: "48px",
  marginBottom: "16px",
  lineHeight: "1",
}));

const CardTitle = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "700",
  color: "#1a1a2e",
  marginBottom: "10px",
}));

const CardDesc = styled(Typography)(() => ({
  fontSize: "14px",
  fontWeight: "400",
  color: "#6b7280",
  lineHeight: "1.6",
  marginBottom: "24px",
  flexGrow: 1,
}));

const CardBtn = styled(Button)(() => ({
  fontSize: "15px",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "none",
  background: "linear-gradient(135deg, #F28021 0%, #e06c10 100%)",
  borderRadius: "10px",
  padding: "12px 28px",
  boxShadow: "0 4px 14px rgba(242,128,33,0.35)",
  width: "100%",
  transition: "opacity 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    opacity: 0.9,
    boxShadow: "0 6px 20px rgba(242,128,33,0.45)",
    background: "linear-gradient(135deg, #F28021 0%, #e06c10 100%)",
  },
}));